/**
 *
 *  SignUpForm
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 02/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";

// Utils
import { isAndroidDevice, isMac, isIosDevice } from "../../utils";

export const PhoneCodeInput = React.forwardRef(
  (
    {
      className,
      inputClassName,
      countryFlag,
      countryShortName,
      phoneCode,
      onClick,
    },
    outerRef
  ) => (
    <div
      ref={outerRef}
      className={`${className} tbk-relative tbk-flex tbk-shrink-0 tbk-cursor-pointer tbk-items-center`}
      onClick={onClick}
    >
      <span className="tbk-absolute tbk-left-2 tbk-select-none tbk-text-3xl">
        {isAndroidDevice || isMac || isIosDevice ? (
          countryFlag
        ) : (
          <img src={countryFlag} className="tbk-w-4" alt={countryShortName} />
        )}
      </span>
      <input
        type="text"
        className={`${inputClassName} tbk-input-field tbk-mb-0 tbk-h-7 ${
          phoneCode && phoneCode.length > 3
            ? "tbk-text-h3-subtitle"
            : "tbk-text-title-medium"
        } tbk-w-29 tbk-cursor-pointer tbk-pl-6 tbk-pr-1`}
        value={phoneCode}
        readOnly
      />
    </div>
  )
);

export default PhoneCodeInput;
